// React
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

// Hooks and utils
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';

// Compoents
import RadioGroup from '@material-ui/core/RadioGroup';
import messages from 'aurora-translations';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import { ADGMTextField, ADGMAlert } from 'aurora-components';
import { injectIntl, FormattedMessage } from 'react-intl';

// Styles
import styles from './styles';

function SecondParty(props) {
  const {
    classes,
    intl,
    fetchCompanyDetails,
    company,
    pmaType,
    individual,
    locale,
    fetchUserDetails,
    secondPartyType,
    isRenewal,
    error,
  } = props;
  const [tradeLicenseNumber, setTradeLicenseNumber] = useState(company?.tradeLicenseNo);
  const [eidNumberOrUnified, setEidNumberOrUnified] = useState(individual?.eidNumberOrUnified);
  const dispatch = useDispatch();
  const handleInputChange = e => {
    if (e.target.name === 'tradeLicenseNumber') setTradeLicenseNumber(e.target.value);
    else setEidNumberOrUnified(e.target.value.replace('-', ''));
  };
  const handleFetch = () => {
    if (pmaType === 'PMC') {
      fetchCompanyDetails(tradeLicenseNumber);
    } else {
      console.log('');
      if (secondPartyType === 'INDIVIDUAL') fetchUserDetails(eidNumberOrUnified);
      else fetchCompanyDetails(tradeLicenseNumber);
    }
  };
  return (
    <div className={classes.contentArea}>
      {pmaType === 'FreeholdPropertyManagementAgreement' && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              <FormattedMessage {...messages.second_party_type} />
            </Typography>
          </div>
          <Grid container xs={12}>
            <Grid item xs={12} spacing={3}>
              <RadioGroup
                className={classes.radioGroup}
                row
                name='PMCType'
                value='COMPANY'
                onChange={e => {
                  dispatch({ type: 'secondPartyType', payload: e.target.value });
                }}
              >
                <FormControlLabel
                  className={classes.radio}
                  value='INDIVIDUAL'
                  checked={secondPartyType === 'INDIVIDUAL'}
                  control={<Radio classes={{ root: classes.radioCheck, checked: classes.checked }} />}
                  label={<FormattedMessage {...messages.Individual} />}
                />
                <FormControlLabel
                  className={classes.radio}
                  value='COMPANY'
                  checked={secondPartyType === 'COMPANY'}
                  control={<Radio classes={{ root: classes.radioCheck, checked: classes.checked }} />}
                  label={<FormattedMessage {...messages.company} />}
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </Paper>
      )}
      {(pmaType === 'PMC' || secondPartyType === 'COMPANY') && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {pmaType === 'FreeholdPropertyManagementAgreement' && <FormattedMessage {...messages.company_details} />}
              {pmaType === 'PMC' && <FormattedMessage {...messages.second_party} />}
            </Typography>
          </div>
          <div style={{ padding: 24 }}>
            <div className={classNames(classes.innerCardGrid, classes.gridItemFullWidth)} style={{ padding: 0 }}>
              <div className={classes.fetchFieldContainer}>
                <ADGMTextField
                  name='tradeLicenseNumber'
                  type='text'
                  value={tradeLicenseNumber || ''}
                  onChange={handleInputChange}
                  label={intl.formatMessage({ ...messages.Trade_license_number })}
                  required
                />
                <Button variant='contained' color='secondary' onClick={handleFetch}>
                  <FormattedMessage {...messages.fetch_details} />
                </Button>
              </div>
              <ADGMAlert type='info' noBackground classes={{ container: classes.dariInfoAlert }}>
                <span className={classes.adgmBlackText}>
                  {keyEmptyCheck('enter_trade_license_warning')}
                  &nbsp; <Link href='#'>{keyEmptyCheck('link content')}</Link>
                </span>
              </ADGMAlert>

              {error && (
                <ADGMAlert type='error' classes={{ container: classes.adgmAlert }}>
                  <span className={classes.adgmBlackText}>
                    {keyEmptyCheck('PMC should be registered in ADGM')}
                    <Link href='#'>{keyEmptyCheck('link content')}</Link>
                  </span>
                </ADGMAlert>
              )}
            </div>
            {company && (
              <div className={classes.innerCardGrid} style={{ padding: 0 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <ADGMTextField
                      name='companyNameEn'
                      type='text'
                      label={intl.formatMessage({ ...messages.company_name_english })}
                      required
                      value={company?.nameEn || ''}
                      disabled
                    />
                  </Grid>
                  <Grid item spacing={3} xs={12} sm={6}>
                    <ADGMTextField
                      name='companyNameAr'
                      type='text'
                      label={intl.formatMessage({ ...messages.company_name_arabic })}
                      required
                      value={company?.nameAr || ''}
                      disabled
                    />
                  </Grid>
                  <Grid item spacing={3} xs={12} sm={6}>
                    <ADGMTextField
                      name='phone_number'
                      type='text'
                      label={intl.formatMessage({ ...messages.phone_number })}
                      required
                      value={company?.phone || ''}
                      disabled
                    />
                  </Grid>
                  <Grid item spacing={3} xs={12} sm={6}>
                    <ADGMTextField
                      name='email'
                      type='text'
                      label={intl.formatMessage({ ...messages.Email })}
                      required
                      value={company?.email || ''}
                      disabled
                    />
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        </Paper>
      )}

      {pmaType === 'FreeholdPropertyManagementAgreement' && secondPartyType === 'INDIVIDUAL' && (
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {isRenewal ? (
                <FormattedMessage {...messages.second_party} />
              ) : (
                <FormattedMessage {...messages.person_details} />
              )}
            </Typography>
          </div>
          <div className={classNames(classes.innerCardGrid, classes.gridItemFullWidth)}>
            <div className={classes.fetchFieldContainer}>
              <ADGMTextField
                name='eidNumberOrUnified'
                type='text'
                value={eidNumberOrUnified || ''}
                onChange={handleInputChange}
                label={intl.formatMessage({ ...messages.UN_EID_number })}
                required
              />
              <Button variant='contained' color='secondary' onClick={handleFetch}>
                <FormattedMessage {...messages.fetch_details} />
              </Button>
            </div>
            <div className={classes.informationMessage}>
              <ADGMAlert type='info' noBackground>
                <FormattedMessage {...messages.enter_un_eid_number_to_fetch_the_person_s_details} />
              </ADGMAlert>
            </div>
          </div>
          <div className={classes.innerCardGrid}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <ADGMTextField
                  name='nameEn'
                  type='text'
                  label={intl.formatMessage({ ...messages.Name_lang }, { lang: 'English' })}
                  required
                  value={individual?.nameEn || ''}
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='nameAr'
                  type='text'
                  label={intl.formatMessage({ ...messages.Name_lang }, { lang: 'Arabic' })}
                  required
                  value={individual?.nameAr || ''}
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='nationality'
                  type='text'
                  label={intl.formatMessage({ ...messages.nationality })}
                  required
                  value={locale === 'en' ? individual?.nationalityEn || '' : individual?.nationalityAr}
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='birthDate'
                  type='text'
                  label={intl.formatMessage({ ...messages.Date_of_birth_DD_MM_YYYY })}
                  required
                  value={individual?.birthDate ? format(new Date(individual?.birthDate), 'dd/MM/yyyy') : ''}
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='passportIssueDate'
                  type='text'
                  label={intl.formatMessage({ ...messages.passport_issue_date })}
                  required
                  value={
                    individual?.passportIssueDate ? format(new Date(individual?.passportIssueDate), 'dd/MM/yyyy') : ''
                  }
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='passportExpiryDate'
                  type='text'
                  label={intl.formatMessage({ ...messages.Passport_expiry_date })}
                  required
                  value={
                    individual?.passportExpiryDate ? format(new Date(individual?.passportExpiryDate), 'dd/MM/yyyy') : ''
                  }
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='phone'
                  type='text'
                  label={intl.formatMessage({ ...messages.phone_number })}
                  required
                  value={individual?.phone || ''}
                  disabled
                />
              </Grid>
              <Grid item spacing={3} xs={12} sm={6}>
                <ADGMTextField
                  name='email'
                  type='text'
                  label={intl.formatMessage({ ...messages.Email })}
                  required
                  value={individual?.email || ''}
                  disabled
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      )}
    </div>
  );
}

SecondParty.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  fetchCompanyDetails: PropTypes.func.isRequired,
  company: PropTypes.object.isRequired,
  pmaType: PropTypes.string.isRequired,
  individual: PropTypes.object.isRequired,
  fetchUserDetails: PropTypes.func.isRequired,
  secondPartyType: PropTypes.string.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

export default withStyles(styles)(injectIntl(SecondParty));
